import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class ApplicationsStateController implements angular.IComponentController {
    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this._$scope.$on(
            '$stateChangeSuccess',
            (_e, toState: angular.ui.IState) => this.currentState = toState
        );
    }

    currentState: angular.ui.IState;
}

export const wtApplicationsState: ComponentDefinition = {
    componentId: 'wtApplicationsState',
    controller: ApplicationsStateController,
    controllerAs: 'vm',
    template: require('./applicationsState.component.html'),
    bindings: {
    }
};